// src\app\[lang]\not-found.tsx
'use client';

import dynamic from 'next/dynamic';
import { usePathname } from 'next/navigation';
import { useMemo } from 'react';

// Dynamically import the Motion404Content to avoid including motion in main bundle
const Motion404Content = dynamic(() => import('./components/Motion404Content'), {
  ssr: false,
  loading: () => (
    <div className="min-h-svh bg-custom-bg flex items-center justify-center">
      <div className="text-communist-red text-2xl font-telegrafico">Loading...</div>
    </div>
  ),
});

// Language content
const content = {
  en: {
    mainTitle: '404',
    subtitle: 'Seized by the revolution.',
    description: 'This page has been redistributed to the people.',
    struggle: 'The revolution continues...',
    homeButton: 'Join the Revolution (Home)',
    footer: 'Workers of the world, unite!',
  },
  fr: {
    mainTitle: '404',
    subtitle: 'Saisie par la révolution.',
    description: 'Cette page a été redistribuée au peuple.',
    struggle: 'La révolution continue...',
    homeButton: 'Rejoindre la Révolution (Accueil)',
    footer: 'Prolétaires de tous les pays, unissez-vous !',
  },
} as const;

export default function NotFound() {
  const pathname = usePathname();

  // Extract language from pathname
  const pathSegments = useMemo(() => {
    return pathname?.split('/').filter(Boolean) || [];
  }, [pathname]);
  const detectedLang = pathSegments[0]?.toLowerCase();

  // Use French if URL starts with /fr/, otherwise default to English
  const lang = detectedLang === 'fr' ? 'fr' : 'en';
  const t = content[lang];

  return <Motion404Content lang={lang} content={t} />;
}
